import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { SolicitudDesembolsoService } from 'app/services/operaciones/solicitud-desembolso/solicitud-des.service';
import { Desembolso } from 'app/models/Desembolso';
import { SolicitudDesembolso } from 'app/models/SolicitudDesembolso';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };
  declare var $: any;
  @Component({
      selector: 'app-nuevo-desembolso',
      templateUrl: './nuevo-desembolso.component.html',
      styleUrls: ['./nuevo-desembolso.component.scss'],
      providers: [MessagesTitles,MessagesGeneral,MessagesDates,
        DatePipe,
      
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE]
        },
    
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
  })

  export class NuevoDesembolsoComponent implements OnInit{

    

    Label_Proveedor=environment.LABEL_PROVEEDOR;
    Label_Proveedores=environment.LABEL_PROVEEDORES;
    Label_Adquirente=environment.LABEL_ADQUIRENTE;
    Label_Adquirentes=environment.LABEL_ADQUIRENTES;
    Label_id_soles=environment.ID_GUIA_SOLES;
    Label_id_dolares=environment.ID_GUIA_DOLARES
    solicitudDesembolsos : any = [];
    check0: boolean = false;
    desembolso : Desembolso[] = [];
    idSolicitudDesembolso : number = 0
    solicitudDesembolsosTotal = [];
    tipoMoneda:string = "1";
    estado ="P";
    idProv ="" ;
    idAdq ="";
    value = '';
    desembolsoGeneral: any = [];

    SolicitudDesembolso:SolicitudDesembolso;

    flag:boolean = false;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    pageSizeOptions = [10,20,30,50,100,200];
    loading:boolean=false;

    displayedColumns: string[] = ['checked','idSolicitudDesembolso','Banco','Fecha_Solicitud_Desembolso','pRazonSocial','aRazonSocial','Moneda_dsc','Desembolso_Importe']

    dataSource :any;

    constructor(private solicitudDesembolsoService:SolicitudDesembolsoService){
      

    }
    applyFilter(filterValue: string) {

      if(null != this.dataSource){
         this.dataSource.filter = filterValue.trim().toLowerCase();
      }
    }

    ngOnInit(){
      this.ListadoSoliDesFiltro()
    }


    ListadoSoliDesFiltro(){
      this.solicitudDesembolsos = [];
      this.desembolsoGeneral = [];
      this.loading = true;
      this.solicitudDesembolsoService.obtenerSolicitudDesembolsoPendientes().subscribe(
        res=>{
            this.solicitudDesembolsos = res;
            if(this.tipoMoneda === "0"){
              this.solicitudDesembolsos = this.solicitudDesembolsos.filter(object => object.Moneda == this.Label_id_soles); 
            } else {
              this.solicitudDesembolsos = this.solicitudDesembolsos.filter(object => object.Moneda == this.Label_id_dolares); 
            }
            this.dataSource = new MatTableDataSource(this.solicitudDesembolsos);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.loading = false;
        }, err =>{
          Swal.fire({
            title:"¡Algo salió mal!",
            text: "No se encuentra información",
            type:"warning",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        }
      )
    }

    Agregar(element: any){
      if(element.checked){
        this.desembolsoGeneral.push(element);
        
      }else{

            
         this.desembolsoGeneral = this.desembolsoGeneral.filter(function(dato){
           if (dato.idSolicitudDesembolso == element['idSolicitudDesembolso']) {
             return false;
           } else {
             return true;
           }
         })

      }
      
      
    }

    openForm(){
      if(this.desembolsoGeneral.length == 0){
        Swal.fire({
          title: 'Atención!',
          text: 'No se han selecionado registros.',
          type: 'info',
          heightAuto: false
        })
      } else {
        this.flag = true;
      }
    }

    CerrarVentana(){
      this.flag = false;
    }

    limpiar(){
      this.desembolsoGeneral = [];
      this.solicitudDesembolsos.map(object => object.checked = false);
    }

    showNotification(type,from,align,message){
    
      $.notify({
          icon: "notifications",
          message: message
      },{
          type: type,
          timer: 4000,
          placement: {
              from: from,
              align: align
          },
          template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
            '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
            '<i class="material-icons" data-notify="icon">notifications</i> ' +
            '<span data-notify="title">{1}</span> ' +
            '<span data-notify="message">{2}</span>' +
            '<div class="progress" data-notify="progressbar">' +
              '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
            '</div>' +
            '<a href="{3}" target="{4}" data-notify="url"></a>' +
          '</div>'
      });
    }

}